import { action } from 'typesafe-actions';
import { STORE_USER, CLEAR_USER } from '../constants/Constants';

import { User } from '../models/User';

export const storeUser = (
  email: string, 
  lidnummer : string, 
  name : string, 
  accessToken: string,
  birthDate: string,
  membershipCardActivatedDate: string,
  userId: string,
  roles: any[]) => action(STORE_USER, 
  {
    email : email, 
    lidnummer : lidnummer,
    name : name,
    accessToken : accessToken,
    birthDate : birthDate,
    membershipCardActivatedDate : membershipCardActivatedDate,
    userId: userId,
    roles: roles
  } as User);

export const clearUser = () => action(CLEAR_USER);
